import * as Types from '../../shared/graphql/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetJeopardyUsersQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.JeopardyUserFilterInput>;
  order?: Types.InputMaybe<Array<Types.JeopardyUserSortInput> | Types.JeopardyUserSortInput>;
}>;


export type GetJeopardyUsersQuery = { __typename?: 'Query', jeopardyUsers?: { __typename?: 'JeopardyUsersConnection', nodes?: Array<{ __typename?: 'JeopardyUser', userId: number, name?: string | null, score?: number | null, location?: string | null, avatar?: string | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type CreateJeopardyGameMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.AddJeopardyGameInput>;
}>;


export type CreateJeopardyGameMutation = { __typename?: 'Mutation', createJeopardyGame?: { __typename?: 'PayloadEntityOfJeopardyGame', entity?: { __typename?: 'JeopardyGame', gameId: number, roomCode?: string | null } | null, errors?: Array<{ __typename?: 'JeopardyApiCoreError', code?: string | null, message?: string | null } | null> | null, warnings?: Array<{ __typename?: 'JeopardyApiCoreWarning', code?: string | null, message?: string | null } | null> | null } | null };

export const GetJeopardyUsersDocument = gql`
    query GetJeopardyUsers($first: Int, $after: String, $last: Int, $before: String, $where: JeopardyUserFilterInput, $order: [JeopardyUserSortInput!]) {
  jeopardyUsers(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      userId
      name
      score
      location
      avatar
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJeopardyUsersGQL extends Apollo.Query<GetJeopardyUsersQuery, GetJeopardyUsersQueryVariables> {
    override document = GetJeopardyUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateJeopardyGameDocument = gql`
    mutation CreateJeopardyGame($input: AddJeopardyGameInput) {
  createJeopardyGame(input: $input) {
    entity {
      gameId
      roomCode
    }
    errors {
      code
      message
    }
    warnings {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateJeopardyGameGQL extends Apollo.Mutation<CreateJeopardyGameMutation, CreateJeopardyGameMutationVariables> {
    override document = CreateJeopardyGameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }